// WHO is paying for a project: the buyer-type vocabulary the admin surfaces tag and
// filter by. An SMB is a business of roughly 5 to 50 people buying for itself; the
// rest of the menu exists so that "not an SMB" is answerable rather than merely
// "not yes".
//
// Mirrors `BUYER_TYPES` in backend/recruiter/tagging/buyer_type.py, which normalizes
// the value at every repo edge (`buyer_type_value`), so the strings here are the only
// ones a payload can carry. "none" is the filter's extra option: a project nothing has
// classified yet (the metadata key is absent until something writes it).
//
// TWO sources decide it, and Fiverr's own field wins: `buyer_identities.company_size`
// (migration 0188) answers it outright for a large share of signed-in buyers, and the
// per-turn model read fills the rest. Measured on a 1120-buyer SMB cohort, the account
// field alone identified 69% of them while a model read of 1000 conversations found
// five — which is why the column is not a pure tagger output.

export const BUYER_TYPES = [
  "smb",
  "solo_professional",
  "individual_consumer",
  "enterprise",
  "unclear",
] as const;

export type BuyerType = (typeof BUYER_TYPES)[number];

/** The human label per type (plus the filter's "none" bucket).
 *
 *  "Unclear" and "Not classified" are deliberately different labels for genuinely
 *  different facts: the first means it was judged and could not be told, the second
 *  that nothing has judged it. Collapsing them would hide how much of the table is
 *  simply unreached. */
export function buyerTypeLabel(value: string): string {
  switch (value) {
    case "smb":
      return "SMB (5-50)";
    case "solo_professional":
      return "Solo professional";
    case "individual_consumer":
      return "Individual";
    case "enterprise":
      return "Enterprise";
    case "unclear":
      return "Unclear";
    case "none":
      return "Not classified";
    default:
      return value;
  }
}
